import React from 'react';
import { getButtonActionsList } from '../../../../config/buttonActions';

export const ButtonForm = ({ component, onUpdate }) => {
  const handleChange = (field, value) => {
    onUpdate(component.id, {
      specificAttrs: { ...component.specificAttrs, [field]: value }
    });
  };

  const { specificAttrs } = component;
  const actions = getButtonActionsList();

  return (
    <div style={{ display: 'grid', gap: '12px' }}>
      <div>
        <label style={{ display: 'block', fontSize: '12px', fontWeight: '500', marginBottom: '4px', color: '#4B5563' }}>
          Button Text
        </label>
        <input
          type="text"
          value={specificAttrs.text || ''}
          onChange={(e) => handleChange('text', e.target.value)}
          style={{
            width: '100%',
            padding: '6px 10px',
            fontSize: '13px',
            border: '1px solid #D1D5DB',
            borderRadius: '6px'
          }}
        />
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
        <div>
          <label style={{ display: 'block', fontSize: '12px', fontWeight: '500', marginBottom: '4px', color: '#4B5563' }}>
            Size
          </label>
          <select
            value={specificAttrs.size || 'medium'}
            onChange={(e) => handleChange('size', e.target.value)}
            style={{
              width: '100%',
              padding: '6px 10px',
              fontSize: '13px',
              border: '1px solid #D1D5DB',
              borderRadius: '6px'
            }}
          >
            <option value="small">Small</option>
            <option value="medium">Medium</option>
            <option value="large">Large</option>
          </select>
        </div>
        <div>
          <label style={{ display: 'block', fontSize: '12px', fontWeight: '500', marginBottom: '4px', color: '#4B5563' }}>
            Border Radius (px)
          </label>
          <input
            type="number"
            value={specificAttrs.borderRadius || 0}
            onChange={(e) => handleChange('borderRadius', e.target.value)}
            min="0"
            style={{
              width: '100%',
              padding: '6px 10px',
              fontSize: '13px',
              border: '1px solid #D1D5DB',
              borderRadius: '6px'
            }}
          />
        </div>
        <div>
          <label style={{ display: 'block', fontSize: '12px', fontWeight: '500', marginBottom: '4px', color: '#4B5563' }}>
            Background Color
          </label>
          <input
            type="color"
            value={specificAttrs.backgroundColor || '#3B82F6'}
            onChange={(e) => handleChange('backgroundColor', e.target.value)}
            style={{
              width: '100%',
              height: '34px',
              border: '1px solid #D1D5DB',
              borderRadius: '6px',
              cursor: 'pointer'
            }}
          />
        </div>
        <div>
          <label style={{ display: 'block', fontSize: '12px', fontWeight: '500', marginBottom: '4px', color: '#4B5563' }}>
            Text Color
          </label>
          <input
            type="color"
            value={specificAttrs.textColor || '#FFFFFF'}
            onChange={(e) => handleChange('textColor', e.target.value)}
            style={{
              width: '100%',
              height: '34px',
              border: '1px solid #D1D5DB',
              borderRadius: '6px',
              cursor: 'pointer'
            }}
          />
        </div>
      </div>
      <div>
        <label style={{ display: 'block', fontSize: '12px', fontWeight: '500', marginBottom: '4px', color: '#4B5563' }}>
          Action
        </label>
        <select
          value={specificAttrs.action || 'none'}
          onChange={(e) => handleChange('action', e.target.value)}
          style={{
            width: '100%',
            padding: '6px 10px',
            fontSize: '13px',
            border: '1px solid #D1D5DB',
            borderRadius: '6px'
          }}
        >
          {actions.map((action) => (
            <option key={action.value} value={action.value}>
              {action.label}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};
